import { useEffect } from 'react';

export const useDocumentTitle = (title = '') => {
  useEffect(() => {
    const prevTitle = document.title;
    const envTitle = process.env.REACT_APP_TITLE ? `- ${process.env.REACT_APP_TITLE}` : '- 2.0';

    if (title) {
      document.title = process.env.REACT_APP_TITLE !== '2.0 MAIN' ? `${title} ${envTitle}` : title;
    }

    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};
